import imgOutside from '../../assets/buildings/house/outside.png';
import imgWasteWater from '../../assets/buildings/house/waste-water.png';
import imgHeating from '../../assets/buildings/house/heating.png';
import imgWater from '../../assets/buildings/house/water.png';
import imgHeatingFr from '../../assets/buildings/house/heatingFr.jpg';
import imgWaterFr from '../../assets/buildings/house/waterFr.jpg';
import { Building, BuildingTechSectors } from '../../interfaces/buildings';
import { TechSector } from '../tech-sector';
import { ProductType } from '../products';
import { activeLanguage } from '../../activeLanguage';

const frenchWater: BuildingTechSectors = {
    type: TechSector.WATER,
    img: imgWaterFr,
    products: [
        {
                position: { x: 90, y: 495 },
            type: ProductType.MULTI_ECO,
        },
        {
                position: { x: 271, y: 336 },
            type: ProductType.FILTRA,
        },
        {
                position: { x: 840, y: 565 },
            type: ProductType.HYA_RAIN_N,
        },
        {
                position: { x: 973, y: 615 },
            type: ProductType.DELTA_BASIC_COMPACT_MVP,
        },
        {
                position: { x: 1724, y: 753 },
            type: ProductType.IXO_PRO,
        },
    ],
};

const frenchHeating: BuildingTechSectors = {
    type: TechSector.HEATING,
    img: imgHeatingFr,
    products: [
        {
                position: { x: 1064, y: 572 },
            type: ProductType.SISTO_16_RGAMAXX,
        },
        {
                position: { x: 1159, y: 565 },
            type: ProductType.CALIO_THERM_S_PRO,
        },
        {
                position: { x: 1269, y: 564 },
            type: ProductType.CALIO_S_PRO,
        },
    ],
};

const houseConfig: Building = {
    techSectors: [
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                        position: { x: 1215, y: 814 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
                {
                        position: { x: 1428, y: 820 },
                    type: ProductType.MINI_COMPACTA,
                },
                {
                        position: { x: 1564, y: 700 },
                    type: ProductType.LEVELCONTROL_BASIC_2,
                },
                {
                        position: { x: 1791, y: 801 },
                    type: ProductType.CK_800,
                },
            ],
        },
        activeLanguage.locale.language === 'fr'
            ? frenchHeating
            : {
                  type: TechSector.HEATING,
                  img: imgHeating,
                  products: [
                      {
                          position: { x: 1078, y: 729 },
                          type: ProductType.SISTO_16_RGAMAXX,
                      },
                      {
                          position: { x: 1202, y: 735 },
                          type: ProductType.CALIO_THERM_S_PRO,
                      },
                      {
                          position: { x: 1321, y: 729 },
                          type: ProductType.CALIO_S_PRO,
                      },
                  ],
              },
        activeLanguage.locale.language === 'fr'
            ? frenchWater
            : {
                  type: TechSector.WATER,
                  img: imgWater,
                  products: [
                      {
                          position: { x: 144, y: 659 },
                          type: ProductType.MULTI_ECO,
                      },
                      {
                          position: { x: 305, y: 492 },
                          type: ProductType.FILTRA,
                      },
                      {
                          position: { x: 896, y: 731 },
                          type: ProductType.HYA_RAIN_2_PLUS,
                      },
                      {
                          position: { x: 483, y: 761 },
                          type: ProductType.AMA_DRAINER_3,
                      },
                      {
                          position: { x: 1013, y: 781 },
                          type: ProductType.DELTA_BASIC_COMPACT_MVP,
                      },
                      {
                          position: { x: 1012, y: 789 },
                          type: ProductType.DELTA_COMPACT,
                      },
                      {
                          position: { x: 1776, y: 901 },
                          type: ProductType.IXO_PRO,
                      },
                  ],
              },
    ],
    img: imgOutside,
};

export default houseConfig;
